import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { enterFullscreen } from '../utils/fullscreen';
import './Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await authAPI.login(formData.username, formData.password);

      if (result.message === 'Login successful') {
        enterFullscreen();
        onLogin(result.data);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="pos-login-wrapper">
      <div className="pos-login-showcase">
        <div className="showcase-content">
          <div className="brand-logo">
            <span className="logo-icon">🏪</span>
            <h1>Light Grocer</h1>
          </div>
          <h2>Next-Gen Point of Sale</h2>
          <p>Streamline your checkout process with our lightning-fast, intuitive cashier interface. Built for performance and reliability.</p>
          <div className="showcase-features">
            <div className="feature-item">
              <span className="feature-icon">⚡</span>
              <span>Fast Checkout</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <span>Real-time Sync</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔒</span>
              <span>Secure Terminal</span>
            </div>
          </div>
        </div>
        {/* Decorative elements */}
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>

      <div className="pos-login-form-side">
        <div className="form-container">
          <div className="form-header">
            <h2>Cashier Login</h2>
            <p>Enter your credentials to start your shift</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <label>Username or Cashier ID</label>
              <div className="input-wrapper">
                <span className="input-icon">👤</span>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  placeholder="Enter username"
                  className="pos-input"
                />
              </div>
            </div>

            <div className="input-group">
              <label>Password or PIN</label>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter password"
                  className="pos-input"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="pos-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <div className="btn-loader"></div>
              ) : (
                'Start Shift'
              )}
            </button>
          </form>

          <div className="form-footer">
            <p>© 2026 <a href="https://www.ellipza.com/" target="_blank" rel="noopener noreferrer">Ellipza</a>. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;